<template>
  <div class="stage_box">
    <i :class="`stage_icon stage_${navNum}`"></i>
  </div>
</template>

<script>
export default {
  props: ['navNum'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.stage_box {
  flex-shrink: 0;
  width: 7.5rem;
  height: 2.7rem;
  background: #feffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .stage_icon {
    width: 6.41rem;
    height: 1.8rem;
  }
  .stage_1 {
    background: url('../../assets/stage_1.png');
    background-size: 100% 100%;
  }
  .stage_2 {
    background: url('../../assets/stage_2.png');
    background-size: 100% 100%;
  }
  .stage_3 {
    background: url('../../assets/stage_3.png');
    background-size: 100% 100%;
  }
  .stage_4 {
    background: url('../../assets/stage_4.png');
    background-size: 100% 100%;
  }
  .stage_5 {
    background: url('../../assets/stage_5.png');
    background-size: 100% 100%;
  }
}
</style>